<template>
    <button
        disabled 
        class="border border-gray-300 bg-gray-300 text-gray-500 whitespace-nowrap flex justify-center items-center rounded-md"
    >
       <slot></slot>    
    </button>
</template>

<script setup>
</script>